import { c as _c } from "react/compiler-runtime";
import styles from "./ReasonForVisit.module.css";
export const DentalImplants = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={`${styles.reasonForVisitIcon} ${styles.reasonForVisitIconDentalImplants}`}><img src="/assets/aspenscheduler/svgs/dental-implants.svg" alt="" width={14} height={22} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};